import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66649b58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          type: "checkbox",
          onChange: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onChangeHandler && _ctx.onChangeHandler(...args)), ["stop"])),
          checked: _ctx.data?.isChecked
        }, null, 40, _hoisted_4),
        _createElementVNode("div", null, _toDisplayString(_ctx.data?.title), 1)
      ]),
      _createElementVNode("div", {
        class: "right",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)), ["prevent"]))
      }, "❌")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["bottom", { isChecked: _ctx.data?.isChecked }])
    }, _toDisplayString(_ctx.data?.context), 3)
  ]))
}